import { render, staticRenderFns } from "./imgDrag_echo.vue?vue&type=template&id=18382291&scoped=true&"
import script from "./imgDrag_echo.vue?vue&type=script&lang=js&"
export * from "./imgDrag_echo.vue?vue&type=script&lang=js&"
import style0 from "./imgDrag_echo.vue?vue&type=style&index=0&id=18382291&scoped=true&lang=scss&"
import style1 from "./imgDrag_echo.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18382291",
  null
  
)

export default component.exports